export default __webpack_public_path__ + "static/media/IndiraChowdhury.2eac1bc5.png";